import { createApp, provide, h } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import VueApexCharts from 'vue3-apexcharts'
import router from './router'

// Apollo (GraphQL)
import { DefaultApolloClient } from '@vue/apollo-composable'
import client from '@/utils/ApolloClient'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

// Global Styles
import '@/assets/variables.scss'
import '@/assets/reset.scss'
import '@/assets/base.scss'
import '@/assets/components.scss'

const vuetify = createVuetify({
  components,
  directives
})

const app = createApp({
  setup() {
    provide(DefaultApolloClient, client)
    return () => h(App)
  }
})

app.use(createPinia())
app.use(router)
app.use(vuetify)
app.use(VueApexCharts)


const prepareApp = async () => {
  if (import.meta.env.VITE_APP_VERSION === 'DEV') {
    const { worker } = await import('./mocks/browser')
    return worker.start()
  }
  return Promise.resolve()
}

prepareApp().then(() => {
  app.mount('#app')
})

